import React, { useReducer, useEffect } from "react";
import { Alert, Card, Col, Row, Table, Badge, Image } from "react-bootstrap";
import ModuleRecordsPerPageDropdown from "../../../../UI/modules/views/partials/common/ModuleRecordsPerPageDropdown";
import ModuleSearchBox from "../../../../UI/modules/views/partials/common/ModuleSearchBox";
import ModuleStatusDropdown from "../../../../UI/modules/views/partials/common/ModuleStatusDropdown";
import ModuleDynamicFilterDropdown from "../../../../UI/modules/views/partials/common/ModuleDynamicFilterDropdown";
import ModuleDynamicMultiFilterDropdown from "../../../../UI/modules/views/partials/common/ModuleDynamicMultiFilterDropdown";
import {
  listingInitialState,
  listingReducer,
} from "../../../../../reducers/module/listingReducer";
import axios from "../../../../../config/axios";
import { getLookupOptionsByName } from "../../../../../helpers/CommonHelper";

const SearchArea = ({
  moduleConfig,
  setFilter,
  appliedFilters,
  resetFilters,
}) => {
  const [listingState, listingDispatch] = useReducer(
    listingReducer,
    listingInitialState
  );

  const loadItems = async () => {
    listingDispatch({ type: "FETCH_REQUEST" });

    try {
      // First API call
      const res = await axios.get(`/lookups`);

      listingDispatch({
        type: "FETCH_SUCCESS",
        payload: res?.data,
      });
    } catch (error) {
      listingDispatch({
        type: "FETCH_FAILURE",
        payload: error,
      });
    }
  };

  useEffect(() => {
    loadItems();
  }, []);
  return (
    <>
      {(appliedFilters.limit ||
        appliedFilters.q ||
        appliedFilters.inStock ||
        appliedFilters["categories[]"] ||
        appliedFilters["materials[]"] ||
        appliedFilters.status) && (
        <div div className=" text-right">
          <span className="resetFilters" onClick={() => resetFilters()}>
            <i className="fas fa-times" /> Reset Filters
          </span>
        </div>
      )}

      <div className="position-relative">
        <Card className="listingPageHeader p-0 m-0 p-1 mt-1 mb-1">
          <Card.Body className=" p-0 m-0">
            <Row className="mb-0">
              {moduleConfig.hasPagination === true &&
                moduleConfig.perPageItemsOptions &&
                moduleConfig.perPageItemsOptions.length > 0 && (
                  <Col className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 col-12 pt-xl-0 pt-lg-0 pt-md-0 pt-0">
                    <ModuleRecordsPerPageDropdown
                      selectedPerPageItems={moduleConfig.perPageItems}
                      perPageItemsOptions={moduleConfig.perPageItemsOptions}
                      setFilter={setFilter}
                    />
                  </Col>
                )}

              {moduleConfig.hasStatusSearch === true && (
                <Col className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 col-12 pt-xl-0 pt-lg-0 pt-md-0 pt-1">
                  <ModuleStatusDropdown
                    setFilter={setFilter}
                    appliedFilters={appliedFilters}
                    statusOptions={[
                      {
                        label: "Select Status...",
                        value: "all",
                      },
                      {
                        label: "Enabled",
                        value: "1",
                      },
                      {
                        label: "Disabled",
                        value: "0",
                      },
                    ]}
                  />
                </Col>
              )}
              <Col className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 col-12 pt-xl-0 pt-lg-0 pt-md-0 pt-1">
                <ModuleDynamicFilterDropdown
                  filterField="inStock"
                  setFilter={setFilter}
                  appliedFilters={appliedFilters}
                  options={[
                    {
                      label: "Select Stock Type...",
                      value: "all",
                    },
                    {
                      label: "In Stock",
                      value: "1",
                    },
                    {
                      label: "Out of Stock",
                      value: "0",
                    },
                  ]}
                />
              </Col>

              {moduleConfig.hasSearch === true && (
                <Col className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 col-12 pt-xl-0 pt-lg-0 pt-md-0 pt-1">
                  <ModuleSearchBox
                    setFilter={setFilter}
                    appliedFilters={appliedFilters}
                  />
                </Col>
              )}
              <Col className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12 pt-xl-0 pt-lg-0 pt-md-0 mt-1">
                <ModuleDynamicMultiFilterDropdown
                  filterField="categories"
                  title="Select Categories"
                  appliedFilters={appliedFilters}
                  setFilter={setFilter}
                  options={getLookupOptionsByName(listingState?.data?.lookups, "Categories")}
                />
              </Col>
              <Col className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12 pt-xl-0 pt-lg-0 pt-md-0 mt-1">
                <ModuleDynamicMultiFilterDropdown
                  filterField="materials"
                  title="Select Materials"
                  appliedFilters={appliedFilters}
                  setFilter={setFilter}
                  options={getLookupOptionsByName(listingState?.data?.lookups, "Materials")}
                />
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default SearchArea;
